var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiletypes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0.5C2.89543 0.5 2 1.39543 2 2.5V22.5C2 23.6046 2.89543 24.5 4 24.5H20C21.1046 24.5 22 23.6046 22 22.5V0.5H4ZM22 0.500016V4.5L18 0.500015L22 0.500016Z",
    fill: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0.5V4.49998H22L18 0.5Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8.5V4.5H18L22 8.5Z",
    fill: "#CBD5E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10.5,
    width: 22,
    height: 10,
    rx: 1,
    fill: "#F43F5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73828 18.5H5.74609V16.6367H6.98828C8.13281 16.6367 8.90625 15.8789 8.90625 14.7539V14.7461C8.90625 13.6172 8.13281 12.8633 6.98828 12.8633H4.73828V18.5ZM6.74219 13.6875C7.46484 13.6875 7.88672 14.0742 7.88672 14.75V14.7578C7.88672 15.4336 7.46484 15.8242 6.74219 15.8242H5.74609V13.6875H6.74219ZM10.0195 18.5H12.1328C13.8203 18.5 14.7852 17.4648 14.7852 15.6602V15.6523C14.7852 13.8867 13.8086 12.8633 12.1328 12.8633H10.0195V18.5ZM11.0273 17.6523V13.7109H12C13.1055 13.7109 13.7578 14.4297 13.7578 15.668V15.6758C13.7578 16.9414 13.1211 17.6523 12 17.6523H11.0273ZM15.9414 18.5H16.9492V16.1992H19.3125V15.3789H16.9492V13.7109H19.5352V12.8633H15.9414V18.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiletypes);
export default __webpack_public_path__ + "static/media/Filetypes.77ec87ab7e0ad4ee767964fef6304576.svg";
export { ForwardRef as ReactComponent };